import axios from "@/lib/axios";
import { useState } from "react";

export const useAnalytics = () => {
    const [eventTracked, setEventTracked] = useState(false);

    const trackEvent = async (eventName, entitySlug, pollHash) => {
        if (!eventName || !entitySlug || !pollHash) {
            console.error("Invalid parameters for tracking event");
            return;
        }
         // Prevent duplicate tracking
        if (eventTracked) return;
        try {
            await axios.post(`/api/${entitySlug}/poll/${pollHash}/analytics`, {
                event: eventName,
            });
            setEventTracked(() => true);
        } catch (error) {
            console.error("Error tracking event:", error);
        }
    };

    return {
        trackEvent
    };
};